import { match } from "path-to-regexp";

export const getOfficeNameFromPath = (path: string): string => {
  const route = "/:companyName/:route(.*)";
  const matchFunction = match(route, {});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchObject: any = matchFunction(path);
  return matchObject === false ? "" : decodeURI(matchObject.params.companyName);
};

export const getRouteWithoutCompanyFromPath = (path: string): string => {
  const route = "/:companyName/:route(.*)";
  const matchFunction = match(route, {});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchObject: any = matchFunction(path);
  return matchObject === false ? "" : decodeURI(matchObject.params.route);
};

export const getOfficeNameFromCurrentHref = (): string => {
  const path = window.location.pathname;
  return getOfficeNameFromPath(path);
};

export const getRouteWithoutCompanyFromCurrentHref = (): string => {
  const path = window.location.pathname;
  return getRouteWithoutCompanyFromPath(path);
};

export const setOfficeNameIntoCurrentHref = (officeShortName: string): void => {
  const url = "/" + officeShortName + "/" + getRouteWithoutCompanyFromCurrentHref();
  window.history.pushState("", "", url);
};

export default getOfficeNameFromCurrentHref;
